import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_LICENSE_SUMMARY_ACTION_TYPE } from '../actions/licenseSummary.actions';

const initialState = null;

const licenseSummaryReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_LICENSE_SUMMARY_ACTION_TYPE.SET_LICENSE_SUMMARY:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default licenseSummaryReducer;
